export default __webpack_public_path__ + "static/media/N0000.d3415f4b.png";